import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class RecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    this.#loadProducts();
  }

  async #loadProducts() {
    const viewedProducts = RecentlyViewed.getProducts();

    if (viewedProducts.length === 0) {
      this.hidden = true;
      return;
    }

    const sectionId = this.dataset.sectionId;
    const maxProducts = parseInt(this.dataset.maxProducts, 10) || 4;
    const productIds = viewedProducts.slice(0, maxProducts);

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set(
      'q',
      productIds.map((id) => `id:${id}`).join(' OR ')
    );
    url.searchParams.set('resources[type]', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const fragment = new DOMParser().parseFromString(html, 'text/html');
      const newSection = fragment.querySelector('recently-viewed-section');

      if (newSection?.innerHTML?.trim()) {
        this.innerHTML = newSection.innerHTML;
        this.hidden = false;
      }
    } catch (error) {
      console.error('Recently viewed products error:', error.message);
      this.hidden = true;
    }
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
